/*
  Sorrel & Co - auto-add the free Hydration Serum gift (added 01Oct26).

  Replaces the BOGOS clone gift, which Supliful cannot fulfill (the clone is
  not published through the Supliful profile, so Supliful declines the whole
  order). This script adds the REAL Supliful-synced Hydration Serum instead,
  and the native Shopify automatic discount "Free Hydration Serum - spend $90"
  (gid://shopify/DiscountAutomaticNode/1881641255166) makes it $0.

  Rules:
  - Eligible when the cart total (after discounts) EXCLUDING the gift line is
    at or above THRESHOLD. Same basis as snippets/cart-progress.liquid.
  - Eligible + no gift line  -> add 1 gift line (tagged _sorrel_gift).
  - Not eligible + gift line -> remove the gift line.
  - Gift quantity above 1    -> set back to 1.
  - Safety net: if the gift is in the cart but the discount did NOT make one
    Hydration Serum free, remove the gift and stop for this cart, so nobody
    is ever charged $38 for a "free" gift.
  - If the customer removes the gift themselves, it is not re-added for
    that cart.
  - Loop guard: at most MAX_ACTIONS automatic cart changes per customer
    action, so a failed request can never retry forever.

  Runs on every page load and after any cart change made through fetch
  (product forms, cart drawer, Skin Plan, apps). Its own requests use the
  original fetch, so they never re-trigger it.
*/
(function () {
  'use strict';

  if (window.__sorrelAutoGift) return;
  window.__sorrelAutoGift = true;
  if (window.Shopify && window.Shopify.designMode) return;

  var GIFT_VARIANT_ID = 48108395495678;
  var GIFT_UNIT_PRICE = 3800;
  var THRESHOLD = 9000;
  var GIFT_PROP = '_sorrel_gift';
  var SECTIONS = 'cart-drawer,cart-icon-bubble';

  var MAX_ACTIONS = 3;

  var origFetch = window.fetch.bind(window);
  var running = false;
  var rerun = false;
  var timer = null;
  var actions = 0;

  function store(key, val) {
    try {
      if (val === undefined) return window.sessionStorage.getItem(key);
      if (val === null) window.sessionStorage.removeItem(key);
      else window.sessionStorage.setItem(key, val);
    } catch (e) {}
    return null;
  }

  function isGiftLine(item) {
    return (
      item.variant_id === GIFT_VARIANT_ID &&
      item.properties &&
      item.properties[GIFT_PROP] !== undefined &&
      item.properties[GIFT_PROP] !== null
    );
  }

  function getCart() {
    return origFetch('/cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' }).then(
      function (r) {
        if (!r.ok) throw new Error('cart.js ' + r.status);
        return r.json();
      }
    );
  }

  function post(url, body) {
    // Loop guard: at most MAX_ACTIONS automatic changes per customer action.
    if (actions >= MAX_ACTIONS) return Promise.resolve(null);
    actions += 1;
    body.sections = SECTIONS;
    body.sections_url = window.location.pathname;
    return origFetch(url, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body),
    }).then(function (r) {
      return r.json().then(function (data) {
        if (!r.ok) throw new Error((data && (data.description || data.message)) || 'cart request failed');
        return data;
      });
    });
  }

  function sectionHTML(html, selector) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var el = doc.querySelector(selector);
    return el ? el.innerHTML : null;
  }

  function refreshUI(data) {
    var onCartPage = /^\/cart\/?$/.test(window.location.pathname);
    if (onCartPage) {
      window.location.reload();
      return;
    }
    var sections = data && data.sections;
    if (!sections) return;

    var drawer = document.querySelector('cart-drawer');
    var drawerInner = document.getElementById('CartDrawer');
    if (sections['cart-drawer'] && drawerInner) {
      var inner = sectionHTML(sections['cart-drawer'], '#CartDrawer');
      if (inner !== null) {
        drawerInner.innerHTML = inner;
        if (drawer) {
          drawer.classList.remove('is-empty');
          var overlay = drawer.querySelector('#CartDrawer-Overlay');
          if (overlay && typeof drawer.close === 'function') {
            overlay.addEventListener('click', drawer.close.bind(drawer));
          }
        }
      }
    }
    var bubble = document.getElementById('cart-icon-bubble');
    if (sections['cart-icon-bubble'] && bubble) {
      var b = sectionHTML(sections['cart-icon-bubble'], '.shopify-section');
      if (b !== null) bubble.innerHTML = b;
    }
  }

  function giftDiscounted(cart) {
    var saved = 0;
    cart.items.forEach(function (item) {
      if (item.variant_id === GIFT_VARIANT_ID) {
        saved += item.original_line_price - item.final_line_price;
      }
    });
    return saved >= GIFT_UNIT_PRICE;
  }

  function reconcile() {
    if (running) {
      rerun = true;
      return Promise.resolve();
    }
    running = true;

    return getCart()
      .then(function (cart) {
        var token = cart.token || 'none';
        var declinedKey = 'sorrelGiftDeclined:' + token;
        var failedKey = 'sorrelGiftFailed:' + token;
        var hadKey = 'sorrelGiftHad:' + token;

        var gift = null;
        var giftFinal = 0;
        cart.items.forEach(function (item) {
          if (isGiftLine(item)) {
            gift = item;
            giftFinal += item.final_line_price;
          }
        });

        var others = cart.total_price - giftFinal;
        var eligible = cart.item_count > 0 && others >= THRESHOLD;

        if (gift) {
          if (!eligible) {
            store(hadKey, null);
            return post('/cart/change.js', { id: gift.key, quantity: 0 });
          }
          if (gift.quantity > 1) {
            return post('/cart/change.js', { id: gift.key, quantity: 1 });
          }
          if (!giftDiscounted(cart)) {
            store(failedKey, '1');
            store(hadKey, null);
            return post('/cart/change.js', { id: gift.key, quantity: 0 });
          }
          store(hadKey, '1');
          return null;
        }

        if (store(hadKey) === '1') {
          // Gift was in this cart and is gone while still eligible:
          // the customer removed it. Respect that for this cart.
          store(hadKey, null);
          if (eligible) store(declinedKey, '1');
          return null;
        }

        if (eligible && store(declinedKey) !== '1' && store(failedKey) !== '1') {
          var props = {};
          props[GIFT_PROP] = '1';
          return post('/cart/add.js', { items: [{ id: GIFT_VARIANT_ID, quantity: 1, properties: props }] }).then(
            function (data) {
              store(hadKey, '1');
              return data;
            }
          );
        }
        return null;
      })
      .then(function (data) {
        if (data) {
          refreshUI(data);
          rerun = true;
        }
      })
      .catch(function (err) {
        if (window.console) console.warn('[sorrel-auto-gift]', err);
      })
      .then(function () {
        running = false;
        if (rerun) {
          rerun = false;
          schedule(250);
        }
      });
  }

  function schedule(delay) {
    clearTimeout(timer);
    timer = setTimeout(reconcile, delay);
  }

  var CART_URL = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/;
  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : input && input.url;
    var p = origFetch(input, init);
    if (url && CART_URL.test(url)) {
      p.then(
        function () {
          actions = 0;
          schedule(400);
        },
        function () {}
      );
    }
    return p;
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      schedule(0);
    });
  } else {
    schedule(0);
  }
})();
